import React from 'react';

const FIGURE_TYPES = ['Spine', 'SkeletonFigure', 'Scale', 'GraveCrossSection', 'Arrow', 'Good'];

const TYPE_BUTTON_CLASSES = {
  Spine: 'box-resizer-btn-spine',
  SkeletonFigure: 'box-resizer-btn-skeleton',
  Arrow: 'box-resizer-btn-arrow',
  GraveCrossSection: 'box-resizer-btn-grave-cross-section',
  Good: 'box-resizer-btn-artefact',
  Scale: 'box-resizer-btn-scale'
};

const TYPE_LABELS = {
  Spine: 'Spine',
  SkeletonFigure: 'Skeleton',
  Arrow: 'Arrow',
  GraveCrossSection: 'GraveCrossSection',
  Good: 'Artefact',
  Scale: 'Scale'
};

// Default coordinates for a newly created figure of `type` inside `grave`
// (the "New Figure" dialog). Spine gets a vertical bar, everything else a
// centered box.
export function deriveCoords(type, grave) {
  if (!grave) return { x1: 0, y1: 0, x2: 100, y2: 100 };

  const width = grave.x2 - grave.x1;
  const height = grave.y2 - grave.y1;

  if (type === 'Spine') {
    return {
      x1: grave.x1 + width * 0.5,
      x2: grave.x1 + width * 0.5,
      y1: grave.y1 + height * 0.6,
      y2: grave.y1 + height * 0.4
    };
  }

  return {
    x1: grave.x1 + width * 0.3,
    x2: grave.x1 + width * 0.6,
    y1: grave.y1 + height * 0.4,
    y2: grave.y1 + height * 0.6
  };
}

export function FigureFormInputs({ figures, onFinish }) {
  if (!onFinish) return null;
  return (
    <button
      type="button"
      className="btn btn-primary box-resizer-card-link mt-2"
      onClick={() => onFinish(Object.values(figures))}
    >
      Next
    </button>
  );
}

export function FigureToolbar({ onTypeSelect }) {
  return (
    <div className="box-resizer-toolbar">
      <div className="box-resizer-btn-group" role="group" aria-label="Figure types">
        {FIGURE_TYPES.map((type) => (
          <button
            key={type}
            type="button"
            className={`btn btn-secondary box-resizer-btn ${TYPE_BUTTON_CLASSES[type]}`}
            onClick={() => onTypeSelect(type)}
          >
            {TYPE_LABELS[type]}
          </button>
        ))}
      </div>
    </div>
  );
}

export function FigureSidebar({
  figures,
  currentEditBox,
  setCurrentEditBox,
  removeEditBox,
  setManualBoundingBox,
  setCreatingNewFigure,
  onFinish
}) {
  return (
    <div className="box-resizer-sidebar card">
      <div className="card-body">
        <h5 className="card-title">Edit Grave</h5>
        <div className="box-resizer-figure-list">
          {Object.values(figures).map((figure) => (
            <React.Fragment key={figure.id}>
              <div
                onClick={() => setCurrentEditBox(figure.id)}
                className={`box-resizer-figure-item ${
                  figure.id === currentEditBox ? 'active' : ''
                }`}
              >
                <div className="box-resizer-figure-name">
                  {figure.typeName === 'Good' ? 'Artefact' : figure.typeName}
                </div>
                <div
                  onClick={(evt) => {
                    evt.stopPropagation();
                    removeEditBox(figure.id);
                  }}
                  className="btn btn-primary badge badge-primary rounded-pill"
                >
                  X
                </div>
              </div>
              {currentEditBox === figure.id &&
                (figure.typeName === 'Grave' || figure.typeName === 'GraveCrossSection') && (
                  <div className="box-resizer-form-check ms-2">
                    <input
                      className="box-resizer-form-check-input"
                      type="checkbox"
                      checked={figure.manual_bounding_box}
                      onChange={(evt) => setManualBoundingBox(figure, evt.target.checked)}
                    />
                    <label className="box-resizer-form-check-label">manual bounding box</label>
                  </div>
                )}
            </React.Fragment>
          ))}
          <a
            href="#"
            onClick={(evt) => {
              evt.preventDefault();
              setCreatingNewFigure(true);
            }}
            className="box-resizer-card-link"
          >
            New Figure
          </a>
        </div>
        <FigureFormInputs figures={figures} onFinish={onFinish} />
      </div>
    </div>
  );
}
